export default __webpack_public_path__ + "static/media/google.36e9057b.png";